
<template>
  <el-select-tree
    v-model="organProjectId"
    v-bind="$attrs"
    :options="busProjectTreeData"
    :default-props="defaultProps"
    :is-leaf="isLeaf"
  />
</template>

<script>
import Cookies from 'js-cookie'
import { commons_busProject } from '@/api/common'
export default {
  name: 'UmBusProject',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    onlyProject: { // 是否只能选择项目
      type: Boolean,
      default: true
    },
    value: {
      type: [String, Number, Array],
      default: null
    },
    // 关闭缓存
    noCache: {
      type: Boolean,
      default: false
    },
    isLeaf: { // 是否只能选择最子级节点
      type: Boolean,
      default: true
    },
    treeData: {
      type: Object,
      default: () => {
        return {
          manageProjectFlag: true, // 是否限定当前用户管辖的项目,默认true
          showProjectParaFlag: false // 是否显示标段，默认false
        }
      }
    },
    defaultProps: {
      type: Object,
      default: () => {
        return {
          value: 'organProjectId',
          label: 'organProjectName',
          children: 'children',
          selectlabel: 'organProjectName'
        }
      }
    },
    // 禁止默认选中
    noSelect: {
      type: Boolean,
      default: false
    },
    // 是否默认选中全部
    selectAll: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      organProjectId: null, // select key
      busProjectTreeData: []
    }
  },
  watch: {
    value(val) {
      if (val == '' || val == null) {
        this.organProjectId = null
      }
      if (val && val !== this.organProjectId) {
        // 全局补字符串
        if (typeof val === 'number') {
          this.organProjectId = val + ''
        } else {
          this.organProjectId = val
        }
      }
    },
    organProjectId(val) {
      this.$emit('change', val)
      if (!this.noCache && typeof val !== 'object') {
        Cookies.set('organProjectId', val)
      }
    }
  },
  created() {
    this.getTree()
  },
  methods: {
    init() {
      let obj = null
      const childList = []
      const deep = list => {
        list.forEach(item => {
          childList.push(item.organProjectId)
          if (item && item.children) {
            deep(item.children)
          }
          if (item.type.indexOf('organ') !== -1 && this.onlyProject) {
            item.disabled = true
          } else {
            item.disabled = false
            if (obj === null) {
              obj = item
            }
          }
        })
      }
      deep(this.busProjectTreeData)
      if (Array.isArray(this.value) && this.value.length === 0 && this.selectAll) {
        this.organProjectId = childList // 如果选择全部
        return false
      }

      if (this.value) {
        if (typeof this.value === 'number') {
          this.organProjectId = this.value + ''
        } else {
          this.organProjectId = this.value
        }
        return false
      }
      // 如果 禁止默认选中 直接退出
      if (this.noSelect) return false

      // 走缓存和默认第一个逻辑
      const id = Cookies.get('organProjectId')
      if (!this.noSelect && id && (JSON.stringify(this.busProjectTreeData).indexOf(`"${id}"`) !== -1)) {
        this.organProjectId = id
      } else {
        this.organProjectId = obj && obj.organProjectId
      }

      // this.$emit('change', this.organProjectId)
    },
    getTree() {
      commons_busProject({
        ...this.treeData
      }).then(d => {
        this.busProjectTreeData = d.data
        this.init()
      })
    }
  }
}
</script>
